import {styled} from "@mui/material/styles"
import {IconButton, Typography} from "@mui/material"

interface NavContainerProps {
    isInSecondaryNav: boolean
    showSecondaryNav: boolean
}

export const BurgerSecondaryNavContainer = styled("div")<NavContainerProps>`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    background: white;
    visibility: ${({showSecondaryNav}) => (showSecondaryNav ? "visible" : "hidden")};
    transform: ${({isInSecondaryNav}) => (isInSecondaryNav ? "translatex(0)" : "translatex(100%)")};
    transition: all 0.3s ease-in-out;
    overflow: hidden;
`

export const BurgerSecondaryNavTitleBar = styled("div")`
    height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`

export const BurgerSecondaryNavSectionTitle = styled(Typography)`
    width: 100%;
    text-align: center;
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
    font-weight: ${({theme}) => theme.uxfabric.global.subtitle2.fontWeight};
    font-family: ${({theme}) => theme.uxfabric.global.subtitle2.fontFamily};
    font-size: ${({theme}) => theme.uxfabric.global.subtitle2.fontSize};
    letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing};
`

export const BurgerSecondaryNavBackButton = styled(IconButton)`
    position: absolute;
    left: 0;
    height: 2.75rem;
    width: 2.75rem;
`

export const BurgerSecondaryNavBackChevron = styled("img")`
    transform: rotate(90deg);
`

export const BugerSecondaryNavLoadingContainer = styled("div")`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const MissionsContainer = styled("section")`
    background: ${({theme}) => theme.uxfabric.background.paper};
    padding: 0.5rem;
    margin-top: 1rem;
    flex: 1;
`

export const BurgerBodyContainer = styled("div")`
    height: 100%;
    flex: 1 1 auto;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
`
